import { render } from "./BreadcrumbSection.vue?vue&type=template&id=a02d1cf0"
import script from "./BreadcrumbSection.vue?vue&type=script&lang=js"
export * from "./BreadcrumbSection.vue?vue&type=script&lang=js"

import exportComponent from "/home/sufoservices/public_html/admin.sufoservices.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__